import { useEffect, useState } from "react";
import api from "../../../api";
import { ServiceHour, HttpError } from "../../../api/types";

/**
 * Custom hook to fetch service hours from backend.
 * @returns {object} - Contains serviceHours, loading state, error state, and refetch function.
 */
function useFetchServiceHours() {
  const [serviceHours, setServiceHours] = useState<ServiceHour[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<HttpError | null>(null);

  const fetchServiceHours = async () => {
    setLoading(true);
    setError(null);

    try {
      const serviceHours = (await api.getServiceHours()) || [];

      if (api.error) {
        setError(api.error);
      }

      setServiceHours(serviceHours);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServiceHours();
  }, []);

  return { serviceHours, loading, error, refetchServiceHours: fetchServiceHours };
}

export default useFetchServiceHours;
